
document.addEventListener('DOMContentLoaded', () => {
  const isMobile = window.innerWidth <= 768;
  const collectionKey = `plp_nudge_${window.location.pathname}`;
  const hasNudgedOnThisPage = sessionStorage.getItem(collectionKey);
  if (isMobile && !hasNudgedOnThisPage) {
    const firstProduct = document.querySelector('.collection__main .product-list');
    if (firstProduct) {
      setTimeout(() => {
        firstProduct.classList.add('js-animate-nudge');
        sessionStorage.setItem(collectionKey, 'true');
        firstProduct.addEventListener('animationend', () => {
          firstProduct.classList.remove('js-animate-nudge');
        }, { once: true });
      }, 1600);
    }
  }
});